import React, { useEffect } from "react";
import "react-datetime/css/react-datetime.css";
import 'tui-calendar/dist/tui-calendar.css';
import Calendar from "@toast-ui/react-calendar";
import { Table } from "react-bootstrap";
import { IEventDateObject, IEventMoreObject, IEventScheduleObject, ISchedule } from "tui-calendar";
import axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import { connect } from "react-redux";
import Loader from "src/components/common/Loader";
import CalendarStateCollapse from "../../components/calendar/calendarStateCollapse"
import { qsStringify } from "src/utilities/helper";
import { Checkbox } from "@fluentui/react";
import "./Calendar.css"

//Calendar interface to recognize calendar Instances in code
//!!r-18-cn
//@ts-ignore
interface MyCalendarProp extends Calendar {
  calendarInst: any
}

//Interface for a calendar schedule
interface scheduleProps {
  id: string
  calendarId: string
  title: string
  category: string
  dueDateClass: string
  start: string
  end: string
  recurrenceRule: string
  bgColor: string
  isReadOnly: boolean
  profitCenters: number
  stateCenters: number
}

//Interface for state and profit center data
interface stateType {
  id: number
  name: string
  displayname?: string
  stateId?: number
}

//Interface for holiday event data
interface holidayProps {
  HolidayDate: string
  HolidayScheduleID: string
  HolidayDescription: string
}

//Interface for Generic dictionary
interface EventDictionary<TValue> {
  [id: string]: TValue
}

//Calendar component
function MyCalendar(props: any) {
  //Contsants used for State/Profit Center/User reference 
  const [reference, setReference] = React.useState({})
  const [profitCenters, setProfitCenters] = React.useState<EventDictionary<{ name: string, ids: EventDictionary<boolean> }>>({})
  const [viewUsers, setViewUsers] = React.useState<EventDictionary<boolean>>({})
  const [users, setUsers] = React.useState<EventDictionary<{ name: string, ProfitCenterId: number }>>({})

  //Constant used for referencing all events in Calendar
  const [events, setEvents] = React.useState<EventDictionary<scheduleProps[]>>({})

  //Constant used for setting page when loading
  const [loading, setLoading] = React.useState(true)

  //Month name reference array for Calendar component
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  //Date references for Calendar and data gather
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)
  const [calDate, setCalDate] = React.useState(currentDate)
  const [date, setDate] = React.useState(monthNames[currentDate.getMonth()] + ", " + currentDate.getFullYear().toString())

  //Calender Reference constant
  const cal = React.createRef<MyCalendarProp>()

  //Calendar view type
  const [views, setViews] = React.useState("month")

  //Constant used for showing events on calendar
  const [schedules, setSchedules] = React.useState<scheduleProps[]>([]);

  //Constant used for referencing calendar object 
  const [calRef, setCalRef] = React.useState<MyCalendarProp | null>()

  //collapsed section 
  const [collapsedSections, setCollapsedSections] = React.useState<{[key: string]: boolean}>({});

  //checking/unchecking a section
  const handleToggleSection = (id: string) => {
    setCollapsedSections(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  //Template for different event types
  const template = {
    allday(event: ISchedule) {
      return `<span style="color:#fff;background-color: ${event.bgColor};">${event.title}</span>`;
    },
    alldayTitle() {
      return 'All Day';
    },
    time(event: ISchedule) {
      return `<span style="color: black;background-color; border: 1px solid; ${event.bgColor};">${event.title}</span>`;
    },
  }

  //Type styling constant
  const [types, setTypes] = React.useState([
    {
      name: "Approved PTO",
      bgColor: "#28a745",
      activated: true
    },
    {
      name: "Holidays",
      bgColor: "#ff00ff",
      activated: true
    },
    {
      name: "Pending PTO",
      bgColor: "#ffc107",
      activated: true
    },
  ])

  //Function used to filter users out of schedule constant
  const filterSchedule = (user: string) => {
    let copyViewUsers = viewUsers
    copyViewUsers[user] = !viewUsers[user]
    setViewUsers(copyViewUsers)
    localStorage.setItem("viewUsers", JSON.stringify(copyViewUsers))
    updateSchedule()
  }

  //Function to handle checkbox change
  const handleCheckChanged = (name: string) => {
    let copyTypes = types.find(obj => {
      return obj.name === name
    })
    let otherTypes = types.filter(obj => (
      obj !== copyTypes
    ))

    if (copyTypes) {
      copyTypes.activated = !copyTypes.activated
      let types = [
        ...otherTypes,
        copyTypes
      ]

      types.sort((a, b) => (
        a.name > b.name ? 1 : -1
      ))

      setTypes(types)
      localStorage.setItem("calendarTypes", JSON.stringify(types))
      updateSchedule()
    }
  }

  //Function used to update the schedual constant
  const updateSchedule = (event = events, viewUser = viewUsers, ty = types) => {
    setLoading(true)
    let schedule: scheduleProps[] = []

    ty.forEach((i) => (
      i.activated && event[i.name] ?
        schedule.push(...event[i.name]) :
        null
    ))

    Object.keys(viewUser).map(i => (
      !viewUser[i] ?
        schedule = schedule.filter(obj => (
          obj.calendarId !== i
        )) : null
    ))
    setLoading(false)
    setSchedules(schedule)
  }

  //Function to get Event data from API
  const getPtOData = async () => {

    let event: EventDictionary<scheduleProps[]> = {}
    let Approved: scheduleProps[] = []
    let Pending: scheduleProps[] = []
    let Holiday: scheduleProps[] = []
    let users: EventDictionary<{ name: string, ProfitCenterId: number }> = {}
    let viewUsers: EventDictionary<boolean> = {}
    const year: Date = new Date(currentDate)
    year.setFullYear(year.getFullYear() + 1)
    let stateProfitCenters: EventDictionary<{ name: string, ids: EventDictionary<boolean> }> = {}
    let profittoStateIds: EventDictionary<number> = {}

    //gather state and profit center data
    axios.get(process.env.REACT_APP_API_URL + "/api/pto/reference", AxiosConfig.configValue("min"))
      .then(res => (
        //r-18-lint-cn
        //eslint-disable-next-line
        setReference({ state: res.data.states, profitCenters: res.data.profitCenters }),
        res.data.states.forEach((i: stateType) => {
          let ProfitCenters: EventDictionary<boolean> = {}
          let profitData = res.data.profitCenters.filter((x: stateType) => x.stateId === i.id)
          profitData.forEach((j: stateType) => (
            //r-18-lint-cn
            //eslint-disable-next-line
            ProfitCenters[j.id] = false,
            //r-18-lint-cn
            //eslint-disable-next-line
            profittoStateIds[`${j.id}`] = i.id
          ))
          stateProfitCenters[`${i.id}`] = { ids: ProfitCenters, name: i.name }
        }),
        setProfitCenters(stateProfitCenters)
      ))
      .catch((err) => {
        //console.log("error", err);
        AxiosConfig.handleError(err);
      })

    //primary data call
    // let start = Date.now()
    axios.post(process.env.REACT_APP_API_URL + "/api/pto/supervisordetail/", qsStringify({ UserId: props.userid }), AxiosConfig.configValue("min"))
      .then((res) => {
        //console.log(process.env.REACT_APP_API_URL + "/api/pto/supervisordetail/", res.data)

        //get holiday dates
        res.data.HolidayDates.forEach((date: holidayProps) => {
          Holiday.push(
            {
              category: "allday",
              bgColor: "#ff00ff",
              end: date.HolidayDate,
              start: date.HolidayDate,
              id: date.HolidayScheduleID,
              calendarId: "1",
              title: `${date.HolidayDescription}`,
              dueDateClass: "",
              recurrenceRule: "",
              isReadOnly: true,
              profitCenters: 0,
              stateCenters: 0
            }
          )
        })

        //get user data
        res.data.users.forEach((user: { id: number, text: string, profitCenterId: number }) => {
          users[`${user.id}`] = { name: user.text, ProfitCenterId: user.profitCenterId }
          if(res.data.defaultProfitCenterId === user.profitCenterId){
            viewUsers[`${user.id}`] = true
          }
          else{
            viewUsers[`${user.id}`] = false
          }
        })

        let copyTypes = types
        let StartDate:string
        let prev: { EntryDate: string, PortalCalendarEntryTypeiD: string, EmployeeID: number } = { EmployeeID: 0, EntryDate: "", PortalCalendarEntryTypeiD: "" }

        //get remaining event types and data
        res.data.types.forEach((type: { PortalCalendarEntryType1: string, PortalCalendarEntryTypeiD: string, Color: string }) => {

          let newType = { name: type.PortalCalendarEntryType1, activated: true, bgColor: type.Color }
          let typeArray: scheduleProps[] = []
          var events = res.data.events.filter((el: { PortalCalendarEntryTypeiD: string }) => el.PortalCalendarEntryTypeiD === type.PortalCalendarEntryTypeiD)
          events.sort((a: any, b: any) => a.EntryDate > b.EntryDate ? 1 : -1)

          events.forEach((i: { EntryDate: string, PortalCalendarEntryTypeiD: string, EmployeeID: number }) => {
            if ((new Date(i.EntryDate).getDate() - new Date(prev.EntryDate).getDate()) / (1000 * 3600 * 24) === 1 && prev.EmployeeID === i.EmployeeID) {
              prev = i
            }
            else if (prev.EntryDate !== "") {
              typeArray.push(
                {
                  category: "allday",
                  bgColor: `${type.Color}`,
                  end: prev.EntryDate,
                  start: StartDate,
                  id: String(prev.PortalCalendarEntryTypeiD),
                  calendarId: `${prev.EmployeeID}`,
                  title: `${users[prev.EmployeeID].name}, ${type.PortalCalendarEntryType1}`,
                  dueDateClass: "",
                  recurrenceRule: "",
                  isReadOnly: true,
                  profitCenters: users[prev.EmployeeID].ProfitCenterId,
                  stateCenters: profittoStateIds[users[prev.EmployeeID].ProfitCenterId]
                }
              )
              StartDate = i.EntryDate
              prev = i
            }
            else {
              prev = i
              StartDate = i.EntryDate
            }

          })

          if (prev.EntryDate !== "") {
            typeArray.push(
              {
                category: "allday",
                bgColor: `${type.Color}`,
                end: prev.EntryDate,
                start: StartDate,
                id: String(prev.PortalCalendarEntryTypeiD),
                calendarId: `${prev.EmployeeID}`,
                title: `${users[prev.EmployeeID].name}, ${type.PortalCalendarEntryType1}`,
                dueDateClass: "",
                recurrenceRule: "",
                isReadOnly: true,
                profitCenters: users[prev.EmployeeID].ProfitCenterId,
                stateCenters: profittoStateIds[users[prev.EmployeeID].ProfitCenterId]
              }
            )
          }

          prev = { EmployeeID: 0, EntryDate: "", PortalCalendarEntryTypeiD: "" }
          if (events.length > 0 && events.find((i: { PortalCalendarEntryTypeiD: string; }) => i.PortalCalendarEntryTypeiD === type.PortalCalendarEntryTypeiD) !== undefined) {
            typeArray.sort((a, b) => a.profitCenters > b.profitCenters || users[a.calendarId].name < users[b.calendarId].name ? 1 : -1)
            event[`${type.PortalCalendarEntryType1}`] = typeArray
            copyTypes.push(newType)
          }


        })

        //get pto data
        let data = res.data.data.filter((obj: any) => obj.status === "Approved" || obj.status === "Pending")
        Object.keys(users).forEach((i) => {

          //filter out data entries by user
          let ledger = data.filter((obj: any) => obj.userId === Number(i))
          ledger.sort((a: { endTimets: string }, b: { endTimets: string }) => a.endTimets > b.endTimets ? 1 : -1)
          let StartDate = 0
          let EndDate = 0
          let status = ""
          let Id = 0
          let title = 0
          let ptoUserId = -99
          let hours = 0
          ledger.forEach((data: any) => (
            //r-18-lint-cn
            //eslint-disable-next-line
            title = data.userId,
            (data.endTimets - EndDate) / ((1000 * 3600 * 24)) === 1 && status === data.status ?
              (EndDate = data.endTimets,
                //combine data entries for consecutive dates 
                hours = hours + Number(data.quantity))
              :
              StartDate !== 0 && status === "Approved" ?
                (
                  Approved.push(
                    {
                      category: "allday",
                      bgColor: "#28a745",
                      end: new Date(EndDate).toUTCString(),
                      start: new Date(StartDate).toUTCString(),
                      id: String(Id),
                      calendarId: `${ptoUserId}`,
                      title: `${users[title].name}, ${hours} hours`,
                      dueDateClass: "",
                      recurrenceRule: "",
                      isReadOnly: true,
                      profitCenters: users[ptoUserId].ProfitCenterId,
                      stateCenters: profittoStateIds[users[ptoUserId].ProfitCenterId]
                    }
                  ),
                  Id = data.ledgerId,
                  StartDate = data.endTimets,
                  EndDate = data.endTimets,
                  status = data.status,
                  ptoUserId = data.userId,
                  hours = Number(data.quantity)
                ) :

                StartDate !== 0 && status === "Pending" ?
                  (
                    Pending.push(
                      {
                        category: "allday",
                        bgColor: "#ffc107",
                        end: new Date(EndDate).toUTCString(),
                        start: new Date(StartDate).toUTCString(),
                        id: String(Id),
                        calendarId: `${ptoUserId}`,
                        title: `${users[title].name}, ${hours} hours`,
                        dueDateClass: "",
                        recurrenceRule: "",
                        isReadOnly: true,
                        profitCenters: users[ptoUserId].ProfitCenterId,
                        stateCenters: profittoStateIds[users[ptoUserId].ProfitCenterId]
                      }
                    ),
                    Id = data.ledgerId,
                    StartDate = data.endTimets,
                    EndDate = data.endTimets,
                    status = data.status,
                    ptoUserId = data.userId,
                    hours = Number(data.quantity)
                  ) :
                  (
                    Id = data.ledgerId,
                    StartDate = data.endTimets,
                    EndDate = data.endTimets,
                    status = data.status,
                    ptoUserId = data.userId,
                    hours = hours + Number(data.quantity)
                  )
          ))
          //add remaining data
          if (StartDate !== 0 && status === "Pending") {
            Pending.push(
              {
                category: "allday",
                bgColor: "#ffc107",
                end: new Date(EndDate).toUTCString(),
                start: new Date(StartDate).toUTCString(),
                id: String(Id),
                calendarId: `${ptoUserId}`,
                title: `${users[title].name}, ${hours} hours`,
                dueDateClass: "",
                recurrenceRule: "",
                isReadOnly: true,
                profitCenters: users[ptoUserId].ProfitCenterId,
                stateCenters: profittoStateIds[users[ptoUserId].ProfitCenterId]
              }
            )
          }

          if (StartDate !== 0 && status === "Approved") {
            Approved.push(
              {
                category: "allday",
                bgColor: "#28a745",
                end: new Date(EndDate).toUTCString(),
                start: new Date(StartDate).toUTCString(),
                id: String(Id),
                calendarId: `${ptoUserId}`,
                title: `${users[title].name}, ${hours} hours`,
                dueDateClass: "",
                recurrenceRule: "",
                isReadOnly: true,
                profitCenters: users[ptoUserId].ProfitCenterId,
                stateCenters: profittoStateIds[users[ptoUserId].ProfitCenterId]
              }
            )
          }
        })

        //sort data by profit center, name, and state
        Approved.sort((a, b) => users[a.calendarId].name > users[b.calendarId].name || a.profitCenters > b.profitCenters || a.stateCenters > b.stateCenters ? 1 : -1)
        Pending.sort((a, b) => users[a.calendarId].name > users[b.calendarId].name || a.profitCenters > b.profitCenters || a.stateCenters > b.stateCenters ? 1 : -1)

        //add data to event dictionary
        event["Holidays"] = Holiday
        event["Approved PTO"] = Approved
        event["Pending PTO"] = Pending

        setEvents(event)
        setUsers(users)

        let copyViewUsers = localStorage.getItem("viewUsers")
        
        //add local storage data for user and type filters 
        if (copyViewUsers) {
          let localView = JSON.parse(copyViewUsers)
          if (JSON.stringify(Object.keys(localView)) === JSON.stringify(Object.keys(viewUsers))) {
            setViewUsers(localView)
            let ty = localStorage.getItem("calendarTypes")
            let bool = true
            if (ty && ty.length === copyTypes.length) {
              let tpe = JSON.parse(ty)
              for (var i = 0; i < tpe.length; i++) {
                if (tpe[i].name !== copyTypes[i].name) {
                  bool = false
                }
              }
            }
            if (ty && bool) {
              setTypes([...JSON.parse(ty)])
              updateSchedule(event, localView, JSON.parse(ty))
            }
            else {
              setTypes([...copyTypes])
              updateSchedule(event, localView)
            }
          }
          else {
            updateSchedule(event, viewUsers)
            setViewUsers(viewUsers)
          }
        }
        else {
          updateSchedule(event, viewUsers)
          setViewUsers(viewUsers)
        }
        // let end = Date.now()
        //console.log("Time taken to load data ", (end - start) / 1000)
      })
      .catch((err) => {
        //console.log("error", err);
        AxiosConfig.handleError(err);
      })
  }
  // Helper function to trigger expand
  const triggerDayViewExpand = () => {
    const btn = document.querySelector('.tui-full-calendar-weekday-exceed-in-week');
    if (!btn) {
      return;
    }

    ['mousedown', 'mouseup'].forEach(eventType => {
      const event = new MouseEvent(eventType, {
        bubbles: true,
        cancelable: true,
        view: window,
        detail: 1
      });
      btn.dispatchEvent(event);
    });
  };

  //handle navigation buttons
  const handleNavigationClick = (e: React.MouseEvent<HTMLButtonElement>, direction = "today") => {

    e.preventDefault();
    if (direction === "prev") {
      cal.current?.calendarInst.prev();
      setDate(monthNames[cal.current?.calendarInst._renderDate._date.getMonth()] + ", " + cal.current?.calendarInst._renderDate._date.getFullYear().toString())
    } else if (direction === "next") {
      cal.current?.calendarInst.next();
      setDate(monthNames[cal.current?.calendarInst._renderDate._date.getMonth()] + ", " + cal.current?.calendarInst._renderDate._date.getFullYear().toString())
    } else if (direction === "today") {
      cal.current?.calendarInst.today();
      setDate(monthNames[cal.current?.calendarInst._renderDate._date.getMonth()] + ", " + cal.current?.calendarInst._renderDate._date.getFullYear().toString())
    }

    const date = new Date(calRef?.calendarInst.getDate())
    setCalDate(date)
  }

  //handle more button click
  const handleMoreClick = (e: IEventMoreObject) => {
    setViews("day")
    calRef?.calendarInst.setDate(e.date.toDate())
    setDate(monthNames[e.date.toDate().getMonth()] + ", " + e.date.toDate().getFullYear().toString())
    setCalDate(e.date.toDate())
  }

  //handle calendar clicks 
  const handleScheduleClick = (e: IEventScheduleObject) => {
    if (views !== "day") {
      setViews("day")
      calRef?.calendarInst.setDate(e.schedule.start)
      setCalDate(calRef?.calendarInst._renderDate._date)
      setDate(monthNames[calRef?.calendarInst._renderDate._date.getMonth()] + ", " + calRef?.calendarInst._renderDate._date.getFullYear().toString())
    }
  }

  const handleDayClick = (e: ISchedule) => {
    setViews("day")
    calRef?.calendarInst.setDate(e.start)
    setCalDate(calRef?.calendarInst._renderDate._date)
    setDate(monthNames[calRef?.calendarInst._renderDate._date.getMonth()] + ", " + calRef?.calendarInst._renderDate._date.getFullYear().toString())
  }

  const handleDayNameClick = (e: IEventDateObject) => {
    if (views !== "day") {
      setViews("day")
      let date = new Date(e.date)
      date.setDate(date.getDate() + 1)
      calRef?.calendarInst.setDate(date)
      setCalDate(calRef?.calendarInst._renderDate._date)
      setDate(monthNames[date.getMonth()] + ", " + date.getFullYear().toString())
    }
  }

  const checkIfAllSelected = () =>{
    var result = true
    Object.keys(viewUsers).forEach(x => {
      if(viewUsers[x] === false){
        result = false
      }
    })
    return result
  }
  const selectAll = () =>{
    var copyViewUsers = viewUsers
    if(checkIfAllSelected() === false){
      Object.keys(viewUsers).forEach((x: string) => {
        copyViewUsers[x] = true
      })
    }
    else{
      Object.keys(viewUsers).forEach(x => {
        copyViewUsers[x] = false
      })
    }
    setViewUsers(copyViewUsers)
    localStorage.setItem("viewUsers", JSON.stringify(copyViewUsers))
    updateSchedule()
  }
  // const getLocalTimezoneOffset = (timestamp: string) => {
  //   return new Date(timestamp).getTimezoneOffset();
  // }

  useEffect(() => {
    setCalRef(cal.current);
    getPtOData()
    //r-18-lint-cn
    //eslint-disable-next-line
  }, [])

  //sets every checkbox in row to be unreachable by keyboard focus 
  useEffect(() => {
    document.querySelectorAll('.calendar-filter-row input[type="checkbox"]').forEach(input => {
      (input as HTMLInputElement).tabIndex = -1;
    });
  });

  useEffect(() => {
    if (views !== "day") return; 
    if (loading) return; 

    const observer = new MutationObserver(() => {
      const btn = document.querySelector('.tui-full-calendar-weekday-exceed-in-week');
      if (!btn) {
        return;
      }
      // Create events with all needed properties
      ['mousedown', 'mouseup'].forEach(eventType => {
        const event = new MouseEvent(eventType, {
          bubbles: true,
          cancelable: true,
          view: window,
          detail: 1,
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          ctrlKey: false,
          altKey: false,
          shiftKey: false,
          metaKey: false,
          button: 0,
          relatedTarget: null
        });
        btn.dispatchEvent(event);
      });

      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
    };
  }, [views, loading]); 

  //watch for date changes in day view
  useEffect(() => {
    if (views !== "day") return;
    
    const btn = document.querySelector('.tui-full-calendar-weekday-exceed-in-week');
    if (btn) {
      ['mousedown', 'mouseup'].forEach(eventType => {
        const event = new MouseEvent(eventType, {
          bubbles: true,
          cancelable: true,
          view: window
        });
        btn.dispatchEvent(event);
      });
    }
  }, [calDate, views]);

  useEffect(() => {
    if (views !== "day") return;
    requestAnimationFrame(() => {
      requestAnimationFrame(triggerDayViewExpand); 
    });

  }, [views, calDate]); 

  return (
    <>
      {
        loading
          ?
          <Loader title="Loading Calendar Data..." classNames="loader" />
          :
          <div className="calendarFilters">
            <div className="calendarItems">
              <table>
                <thead>
                  <tr>
                    <th><i className="material-icons">calendar_month</i></th>
                    <th>Calendars</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    types.map((i, items) => (
                      events[i.name] ?
                        <tr 
                        key={items} 
                        className="calendar-filter-row" 
                        onClick={e => {
                          if((e.target as HTMLElement).tagName !== "INPUT"){
                            handleCheckChanged(i.name)
                          }
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => {
                          if(e.key === "Space" || e.key === " "){
                            handleCheckChanged(i.name)
                          }
                        }}
                        aria-pressed={i.activated}>
                            <td>
                                <Checkbox className="checked" 

                                  styles={i.activated ? {
                                    checkbox: {
                                      background: i.bgColor,
                                      borderColor: 'black',
                                      mdiFormatVerticalAlignCenter: true
                                    }
                                  } : {}}
                                  checked={i.activated}
                                  //onChange={() =>  handleCheckChanged(i.name)}
                                  />
                            </td>
                          <td>{i.name}</td>
                        </tr>
                        : null
                    ))
                  }
                </tbody>
              </table>
            </div>
            <div className="userFilter">
              <Table>
                <thead>
                  <tr className="userHead">
                    <th>States</th>
                    <th><input type="checkbox" checked={checkIfAllSelected()} onChange={() => selectAll()}/></th>
                  </tr>
                </thead>
                {Object.keys(profitCenters).map((i, index) => {
                  let copyProfitCentersId = profitCenters[i].ids
                  Object.keys(copyProfitCentersId).forEach((center) => {
                    copyProfitCentersId[center] = false
                  })
                  Object.keys(users).forEach((user) => {
                    if (viewUsers[user] && copyProfitCentersId[users[user].ProfitCenterId] !== undefined) {
                      copyProfitCentersId[users[user].ProfitCenterId] = true
                    }
                  })
                  return (
                    <tbody key={index} className="stateBody">
                      <CalendarStateCollapse 
                        checked={viewUsers} 
                        key={i} 
                        state={profitCenters[i].name} 
                        profitCenters={copyProfitCentersId} 
                        reference={reference} 
                        users={users} 
                        change={filterSchedule} 
                        startOpen={!!collapsedSections[i]} 
                        onToggle={() => handleToggleSection(i)} 
                      />
                    </tbody>

                  );
                })}
              </Table>
            </div>
          </div>

      }
      <div className="Calendar">
        <h3>{date}</h3>
        <button onClick={() => { 
          setViews("month");
        }} disabled={views === "month"}>Month</button>
        <button onClick={() => { 
          setViews("week");
        }} disabled={views === "week"}>Week</button>
        <button onClick={() => { 
          setViews("day");
          requestAnimationFrame(triggerDayViewExpand);
        }} disabled={views === "day"}>Day</button>
        {/*!!r-18-cn*/}
        {/*@ts-ignore*/}
        <Calendar
          isReadOnly={false}
          ref={cal}
          height="700px"
          //!!r-18-cn
          //@ts-ignore
          view={views}
          template={template}
          schedules={schedules}
          //!!r-18-cn
          //@ts-ignore
          onClickMore={(e) => (handleMoreClick(e))}
          //!!r-18-cn
          //@ts-ignore
          onClickSchedule={(e) => handleScheduleClick(e)}
          //!!r-18-cn
          //@ts-ignore
          onBeforeCreateSchedule={(e) => handleDayClick(e)}
          //!!r-18-cn
          //@ts-ignore
          onClickDayname={(e) => handleDayNameClick(e)}
          theme={{ 'common.saturday.color': '#ff4040' }}
          taskView={false}
        />
        <button onClick={(e) => handleNavigationClick(e, "prev")}><i className="navButtons material-icons">arrow_back_ios</i></button>
        <button onClick={(e) => handleNavigationClick(e)} disabled={calDate.toISOString() === currentDate.toISOString()}><i className="navButtons material-icons">today</i></button>
        <button onClick={(e) => handleNavigationClick(e, "next")}><i className="navButtons material-icons">arrow_forward_ios</i></button>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => ({
  username: state.user.userName,
  userid: state.user.userId,
  homeProfitCenterID: state.user.homeProfitCenter
})

export default connect(mapStateToProps)(MyCalendar);



